'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/react-select/lib/utils/blockEvent.js
// module id = 2860
// module chunks = 0